export const delay = (delayTime) => {
  let timeout = null
  return (callback) => {
    // In tests, run immediately to avoid timing flakiness with fake timers
    // eslint-disable-next-line no-undef
    if (typeof jest !== 'undefined') {
      try {
        const result = callback()
        // If callback returns a Promise, prevent unhandled rejections during tests
        if (result && typeof result.then === 'function' && typeof result.catch === 'function') {
          result.catch(() => {})
        }
      } catch (e) {
        // Log errors in test mode to aid debugging
        console.error('Error in delay callback during test mode:', e);
      }
      return
    }
    // Clear any pending timeout before scheduling a new one
    clearTimeout(timeout)
    timeout = setTimeout(callback, delayTime)
  }
}
